import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import { installChunkReload } from "./app/chunkReload";

installChunkReload();

async function boot() {
  // Dev-only mock API + fake sign-in (`yarn dev:mock`). Dead-code
  // eliminated from production builds.
  if (import.meta.env.DEV && import.meta.env.NA_MOCK === "true") {
    const { startMocks } = await import("./mocks/browser");
    await startMocks();
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}

boot();
